import
  React
from 'react';

import
  styled
from 'styled-components';


import {
  Colors,
  DataStore,
  FontSizes,
  FontFamilies,
  MediaQueries,
  Image,
  Theme,
  Logger,
  isValidProviderResult
} from 'common';

import {
  Arrow,
  Button,
  Card,
  Modal,
  NumericSelect,
  ShareMeta,
  Stepper,
  Text,
} from 'common/components';

import {
  withCommon,
} from 'common/hocs';

import {
  EventMobileTicketSummary
} from 'ui/event/components';

import {
  ActionContainer,
  Container,
  DetailContainer,
  DetailContent,
  DetailContentText,
  DesktopContentSpace,
  EventName,
  FullWidthContainer,
  MainContentContainer,
  MobileContentSpace,
  SideContentContainer,
  SideContent,
  StepperContainer,
} from 'ui/event/styled';

import {
  EventProvider
} from 'providers';

import { getCheckoutSteps } from 'ui/event/eventUtils';

const isBolandRugbyHost =
  typeof window !== 'undefined' &&
  window.location.hostname.includes('bolandrugby.co.za');

const ActionContainerPopupOverlay = styled.div`
  background-color: ${Colors.Black}60;

  position: fixed;
  bottom: 65px;
  left: 0;
  top: 0;
  right: 0;
  z-index: 1;

  ${props => !props.show && 'display: none;'}

  @media only screen and ${MediaQueries.Md} {
    display: none;
  }
`;

const ActionContainerPopup = styled.div`
  background-color: ${Theme.EventDetails.ActionContainerBackground};
  width: 100%;

  position: fixed;
  bottom: ${props => props.show ? (isBolandRugbyHost ? '138px' : '65px') : '-100%'};
  left: 0;

  transition: bottom 0.5s ease 0s;
  z-index: 1;

  @media only screen and ${MediaQueries.Md} {
    display: none;
  }
`;

const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 15px 0 0;
`;

const MerchContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and ${MediaQueries.Md} {
    flex-direction: row;
  }
`;

const VariantContainer = styled.div`
  flex: 1;
  padding: 15px 0 0 0;

  @media only screen and ${MediaQueries.Md} {
    padding: 0 0 0 20px;
  }
`;

const PackageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  width: 100%;

  @media only screen and ${MediaQueries.Md} {
    flex-direction: row;
  }
`;

const PackageImageContainer = styled.div`
  padding: 10px 0;

  @media only screen and ${MediaQueries.Md} {
    padding: 0;
    margin-right: 20px;
  }
`;

const PackageDetailsContainer = styled.div`
  flex: 1;
`;

const PriceAndSelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
  justify-content: space-between;
`;

const IncludedItemsContainer = styled.div`
  margin-top: 15px;
  padding: 0 10px 10px 0;
  background-color: ${Colors.LightGray}30;
  border-radius: 8px;
`;

const IncludedItemRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const CheckIcon = styled.span`
  color: ${Colors.Success};
  margin-right: 8px;
`;

const PackageVariantContainer = styled.div`
  background-color: ${Colors.LightGray}20;
  border-radius: 8px;
`;

const PackageVariantRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const PackageVariantLabel = styled.div`
  margin-bottom: 8px;
`;

const VariantButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const VariantButton = styled.button`
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid ${props => props.selected ? Colors.PrimaryOne : Colors.Gray};
  background-color: ${props => props.selected ? `${Colors.PrimaryOne}` : 'white'};
  color: ${props => props.selected ? Colors.White : Colors.Black};
  font-weight: ${props => props.selected ? 'bold' : 'normal'};
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  
  &:hover {
    border-color: ${Colors.Primary};
    background-color: ${props => props.selected ? `${Colors.Primary}20` : `${Colors.Primary}10`};
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    border-color: ${Colors.Gray};
    background-color: ${Colors.LightGray};
  }
`;

const EventTicketSelectUI = props => {

  const [state, setState] = React.useState({
    ticketPrices: [],
    products: [],
    packages: [],
    event: {}
  });

  const [totals, setTotals] = React.useState(DataStore.get('selectedTickets') || {
    selectedTickets: {},
    selectedMerch: {},
    selectedPackages: {},
    price: 0,
    tickets: 0,
  });

  const [showSummary, setShowSummary] = React.useState(false);

  const [packageVariants, setPackageVariants] = React.useState({});

  const [showProductCheckModal, setShowProductCheckModal] = React.useState(false);
  const [productCheckMessage, setProductCheckMessage] = React.useState('');

  const description = React.useMemo(() => {
    return window.location.href.includes('bolandrugby')
      ? '*Note: Merchandise needs to be collected from the Boland Rugby Stadium on matchday.'
      : 'Select Products below to be added to your order.';
  }, []);

  const onShowSummaryClick = () => {

    setShowSummary(true);
  };

  const onHideSummaryClick = () => {

    setShowSummary(false);
  };

  // Configuration for product IDs that require confirmation
  // Format: { productId: 'message to show' }
  const PRODUCT_CHECK_CONFIG = {
    '17': 'This product requires special handling. Do you want to continue?',
    '18': 'This product requires special handling. Do you want to continue?',
    '19': 'This product requires special handling. Do you want to continue?',
    '20': 'This product requires special handling. Do you want to continue?',
    '21': 'This product requires special handling. Do you want to continue?',
    '22': 'This product requires special handling. Do you want to continue?',
    '23': 'This product requires special handling. Do you want to continue?',
    '24': 'This product requires special handling. Do you want to continue?',
    '25': 'This product requires special handling. Do you want to continue?'
  };

  // Check if any selected products match the configured product IDs
  const checkSelectedProducts = () => {
    const selectedMerch = totals.selectedMerch || {};
    const productIdsToCheck = Object.keys(PRODUCT_CHECK_CONFIG);
    
    if (productIdsToCheck.length === 0) {
      return null; // No products to check
    }

    console.log(productCheckMessage);

    // Check if any selected products match the configured IDs
    for (const merch of Object.values(selectedMerch)) {
      if (merch.count > 0 && merch.product_id) {
        const productIdStr = String(merch.product_id);
        if (productIdsToCheck.includes(productIdStr)) {
          return PRODUCT_CHECK_CONFIG[productIdStr];
        }
      }
    }

    return null; // No matching products found
  };

  // Proceed with checkout after modal acceptance
  const proceedToCheckout = () => {
    setShowProductCheckModal(false);
    setProductCheckMessage('');
    props.common.navigate('/event/ticket/identity');
  };

  // Handle checkout button click with product check
  const handleCheckout = () => {
    if (totals.tickets === 0) {
      props.common.showToast('Please add items before checkout');
      return;
    }

    if (!areAllVariantsSelected()) {
      props.common.showToast('Please select variants for all packages');
      return;
    }

    // Check for products that require confirmation
    const checkMessage = checkSelectedProducts();
    if (checkMessage) {
      setProductCheckMessage(checkMessage);
      setShowProductCheckModal(true);
      return;
    }

    // No special products, proceed directly
    proceedToCheckout();
  };

  const onTicketCounterChange = (count, priceId) => {

    if (!priceId) {
      return;
    }

    let currentTicket = state.ticketPrices.find((tp) => tp.id === priceId);

    if (!currentTicket) {
      return;
    }

    const selectedTickets = totals.selectedTickets;

    selectedTickets[priceId] = {
      ...currentTicket,
      count: count,
      totalPrice: count * currentTicket.price,
    };

    let totalPrice = 0;
    let totalTickets = 0;

    for (const item of Object.values(selectedTickets)) {

      totalPrice += item.totalPrice;
      totalTickets += item.count;
    }

    for (const item of Object.values(totals.selectedMerch)) {

      totalPrice += item.totalPrice;
      totalTickets += item.count;
    }

    for (const item of Object.values(totals.selectedPackages)) {

      totalPrice += item.totalPrice;
      totalTickets += item.count;
    }

    setTotals(prevState => ({
      ...prevState,
      selectedTickets: selectedTickets,
      price: totalPrice,
      tickets: totalTickets,
    }));

    setTimeout(() => {
      DataStore.set('selectedTickets', {
        selectedTickets: selectedTickets,
        selectedMerch: totals.selectedMerch,
        selectedPackages: totals.selectedPackages,
        price: totalPrice,
        tickets: totalTickets
      });
    }, 0);
  };

  const onMerchCounterChange = (count, product_id, option_id) => {

    if (!product_id && !option_id) {
      return;
    }

    const product = state.products.find(p => p.product_id === product_id);

    const variant = product.variants.find(v => v.option_id === option_id);

    const selectedMerch = totals.selectedMerch;

    const key = product.is_simple_product ? `product-${product.product_id}` : `variant-${variant.option_id}`;

    selectedMerch[key] = {
      ...product.is_simple_product ? {} : variant,
      product_name: product.product_name,
      description: product.description,
      product_id: product.product_id || product.id,
      is_simple_product: product.is_simple_product,
      delivery_type: product.delivery_type,
      count: count,
      totalPrice: count * (product.is_simple_product ? product.price : variant.price),
    };

    let totalPrice = 0;
    let totalTickets = 0;

    for (const item of Object.values(totals.selectedTickets)) {

      totalPrice += item.totalPrice;
      totalTickets += item.count;
    }

    for (const item of Object.values(selectedMerch)) {

      totalPrice += item.totalPrice;
      totalTickets += item.count;
    }

    for (const item of Object.values(totals.selectedPackages)) {

      totalPrice += item.totalPrice;
      totalTickets += item.count;
    }

    setTotals(prevState => ({
      ...prevState,
      selectedMerch: selectedMerch,
      price: totalPrice,
      tickets: totalTickets,
    }));

    setTimeout(() => {
      DataStore.set('selectedTickets', {
        selectedTickets: totals.selectedTickets,
        selectedMerch: selectedMerch,
        selectedPackages: totals.selectedPackages,
        price: totalPrice,
        tickets: totalTickets
      });
    }, 0);
  };

  const onPackageCounterChange = (count, packageData) => {
    if (!packageData) return;

    const selectedPackages = {...totals.selectedPackages};
    const packageId = packageData.id || 'package-1';

    // Clear or update selected packages
    if (count === 0) {
      if (selectedPackages[packageId]) {
        delete selectedPackages[packageId];
      }
      // Clear variant selections for this package
      const newVariants = {...packageVariants};
      Object.keys(newVariants).forEach(key => {
        if (key.startsWith(`${packageId}-`)) {
          delete newVariants[key];
        }
      });
      setPackageVariants(newVariants);
    } else {
      // If increasing count, maintain existing variants or initialize new ones
      const newVariants = {...packageVariants};
      
      // Remove excess variant selections if count decreased
      // The key structure is: ${packageId}-${itemId}-${index}
      Object.keys(newVariants).forEach(key => {
        if (key.startsWith(`${packageId}-`)) {
          const parts = key.split('-');
          if (parts.length >= 3) {
            const index = parseInt(parts[parts.length - 1]);
            if (index > count) {
              delete newVariants[key];
            }
          }
        }
      });
      
      setPackageVariants(newVariants);
      
      // Update selected packages - only store essential data
      // Preserve existing variants if they exist, but filter out indices beyond new count
      const existingVariants = selectedPackages[packageId]?.variants || {};
      const filteredVariants = {};
      
      // For each item, filter out variants for package indices beyond the new count
      Object.keys(existingVariants).forEach(itemId => {
        const itemVariants = existingVariants[itemId] || {};
        const filteredItemVariants = {};
        
        Object.keys(itemVariants).forEach(index => {
          if (parseInt(index) <= count) {
            filteredItemVariants[index] = itemVariants[index];
          }
        });
        
        if (Object.keys(filteredItemVariants).length > 0) {
          filteredVariants[itemId] = filteredItemVariants;
        }
      });
      
      selectedPackages[packageId] = {
        name: packageData.name,
        packageId: packageId,
        count: count,
        price: packageData.price,
        totalPrice: count * packageData.price,
        variants: filteredVariants
      };
    }

    let totalPrice = 0;
    let totalTickets = 0;

    // Calculate totals from tickets
    for (const item of Object.values(totals.selectedTickets)) {
      totalPrice += item.totalPrice;
      totalTickets += item.count;
    }

    // Calculate totals from merch
    for (const item of Object.values(totals.selectedMerch)) {
      totalPrice += item.totalPrice;
      totalTickets += item.count;
    }

    // Calculate totals from packages
    for (const item of Object.values(selectedPackages)) {
      totalPrice += item.totalPrice;
      totalTickets += item.count;
    }

    setTotals(prevState => ({
      ...prevState,
      selectedPackages: selectedPackages,
      price: totalPrice,
      tickets: totalTickets,
    }));

    setTimeout(() => {
      DataStore.set('selectedTickets', {
        selectedTickets: totals.selectedTickets,
        selectedMerch: totals.selectedMerch,
        selectedPackages: selectedPackages,
        price: totalPrice,
        tickets: totalTickets
      });
    }, 0);
  };

  const onVariantSelect = (packageId, itemId, packageIndex, variantId) => {
    const packageData = state.packages.find(p => p.id === packageId);

    if (!packageData || !packageData.items) return;
    
    // Find the product item with variants by item ID
    const productItem = packageData.items.find(
      item => (String(item.id) === String(itemId) || String(item.item_id) === String(itemId)) &&
              item.item_type === 'product_id' && 
              item.item_details && 
              item.item_details.variants && 
              item.item_details.variants.length > 0
    );
    
    if (!productItem || !productItem.item_details) return;
    
    const variant = productItem.item_details.variants.find(v => v.option_id === variantId);
    if (!variant) return;
    
    const variantKey = `${packageId}-${itemId}-${packageIndex}`;
    
    setPackageVariants(prev => ({
      ...prev,
      [variantKey]: variant
    }));
    
    // Update the totals with the variant information - only store essential variant data
    const selectedPackages = {...totals.selectedPackages};
    if (selectedPackages[packageId]) {
      // Only store minimal variant info needed for checkout
      const variantInfo = {
        option_id: variant.option_id,
        option_value: variant.option_value,
        product_variant_id: variant.product_variant_id,
        delivery_type: productItem.item_details.delivery_type
      };
      
      // Store variants per item: variants[itemId][packageIndex] = variantInfo
      // Ensure itemId is stored as string for consistency
      const itemIdStr = String(itemId);
      const itemVariants = selectedPackages[packageId].variants?.[itemIdStr] || {};
      
      selectedPackages[packageId] = {
        ...selectedPackages[packageId],
        variants: {
          ...selectedPackages[packageId].variants,
          [itemIdStr]: {
            ...itemVariants,
            [packageIndex]: variantInfo
          }
        }
      };
      
      setTotals(prev => ({
        ...prev,
        selectedPackages
      }));
      
      // Update DataStore
      setTimeout(() => {
        DataStore.set('selectedTickets', {
          ...totals,
          selectedPackages
        });
      }, 0);
    }
  };

  const areAllVariantsSelected = () => {
    // Check all packages for variant requirements
    for (const packageData of state.packages) {
      const packageId = packageData.id || 'package-1';
      const packageCount = totals.selectedPackages[packageId]?.count || 0;
      
      if (packageCount === 0) continue;
      
      // Check if there are any product items with variants
      if (!packageData.items) continue;
      
      // Find ALL product items with variants
      const productItemsWithVariants = packageData.items.filter(
        item => item.item_type === 'product_id' && 
                item.item_details && 
                item.item_details.variants && 
                item.item_details.variants.length > 0
      );
      
      // If no products with variants, variants are not required for this package
      if (productItemsWithVariants.length === 0) continue;
      
      // Check if all package indices have variants selected for ALL product items
      for (const productItem of productItemsWithVariants) {
        const itemIndex = productItemsWithVariants.indexOf(productItem);
        const itemId = String(productItem.id || productItem.item_id || `item-${itemIndex}`);
        
        for (let i = 1; i <= packageCount; i++) {
          const variantKey = `${packageId}-${itemId}-${i}`;
          if (!packageVariants[variantKey]) {
            return false;
          }
        }
      }
    }
    
    return true;
  };

  const renderIncludedItems = (packageData) => {
    if (!packageData || !packageData.items) return null;
    
    return (
      <IncludedItemsContainer>
        <Text fontFamily={FontFamilies.Bold} fontSize={FontSizes.Small} padding={'0 0 10px 0'}>
          Package Includes:
        </Text>
        
        {packageData.items.map((item, index) => {
          let itemName = '';
          
          if (item.item_type === 'product_id' && item.item_details) {
            itemName = item.item_details.product_name || 'Product';
          } else if (item.item_type === 'event_price_id' && item.item_details) {
            itemName = item.item_details.title || 'Ticket';
          }
          
          return (
            <IncludedItemRow key={`included-item-${index}`}>
              <CheckIcon>✓</CheckIcon>
              <Text fontSize={FontSizes.Small}>
                {itemName}
              </Text>
            </IncludedItemRow>
          );
        })}
      </IncludedItemsContainer>
    );
  };

  const renderProductVariants = (packageData) => {
    if (!packageData || !packageData.items) return null;
    
    // Find ALL product items with variants
    const productItemsWithVariants = packageData.items.filter(
      item => item.item_type === 'product_id' && 
              item.item_details && 
              item.item_details.variants && 
              item.item_details.variants.length > 0
    );
    
    if (productItemsWithVariants.length === 0) return null;
    
    const packageId = packageData.id || 'package-1';
    const packageCount = totals.selectedPackages[packageId]?.count || 0;
    
    if (packageCount === 0) return null;
    
    // Create an array of package indices
    const packageIndices = Array.from({length: packageCount}, (_, i) => i + 1);
    
    return (
      <>
        {productItemsWithVariants.map((productItem, itemIndex) => {
          const itemId = String(productItem.id || productItem.item_id || `item-${itemIndex}`);
          const variants = productItem.item_details.variants;
          
          return (
            <Card
              key={`variant-card-${itemId}`}
              backgroundColor={Theme.Card.Background}
              alignItems={'flex-start'}
              flexDirection={'column'}
              padding={'20px'}
              margin={'0 0 20px 0'}
              width={'100%'}>
              
              <Text fontSize={FontSizes.Medium} fontFamily={FontFamilies.Bold} padding={'0 0 10px 0'}>
                {productItem.item_details?.product_name}
              </Text>
              
              <PackageVariantContainer>
                {packageIndices.map(index => {
                  const variantKey = `${packageId}-${itemId}-${index}`;
                  const selectedVariant = packageVariants[variantKey];
                  
                  return (
                    <PackageVariantRow key={variantKey}>
                      <PackageVariantLabel>
                        <Text fontFamily={FontFamilies.Bold}>
                          Package {index}:
                        </Text>
                      </PackageVariantLabel>
                      <VariantButtonsContainer>
                        {variants.map(variant => {
                          const isSelected = selectedVariant?.option_id === variant.option_id;
                          const outOfStock = variant.available_stock <= 0;
                          
                          return (
                            <VariantButton 
                              key={variant.option_id}
                              selected={isSelected}
                              disabled={outOfStock}
                              onClick={() => !outOfStock && onVariantSelect(packageId, itemId, index, variant.option_id)}
                            >
                              {variant.option_value}
                            </VariantButton>
                          );
                        })}
                      </VariantButtonsContainer>
                    </PackageVariantRow>
                  );
                })}
              </PackageVariantContainer>
            </Card>
          );
        })}
      </>
    );
  };

  const load = () => {

    if (!props.common?.pathParams?.id) {

      Logger.error('EventTicketSelect', 'load', 'No eventID provided');
      props.common.showToast('Oh no, we weren\'t able to load the event details, please try again.');
      return;
    }

    const eId = typeof props.common.pathParams.id === 'string'
      ? props.common.pathParams.id.split('-')[0]
      : props.common.pathParams.id;

    EventProvider.getEventById(eId)
      .then(ret => {

        props.common.hideLoading();

        if (!isValidProviderResult(ret)) {

          if (ret.message === 'Event not live' || ret.message === 'Event not found') {
            Logger.info('EventTicketSelect', 'load', `Error loading event details ${props.common.pathParams.id}: ${ret.message}`);
            props.common.navigate('/');
            return;
          }

          Logger.error('EventTicketSelect', 'load', `Error loading event details ${props.common.pathParams.id}: ${ret.message}`);
          props.common.showToast('Oh no, we weren\'t able to load the event details, please try again.');
          return;
        }

        setState(prevState => ({
          ...prevState,
          ticketPrices: ret.data.prices || [],
          event: ret.data
        }));

        DataStore.set('selectedEvent', ret.data);
      })
      .catch(e => {

        Logger.error('EventTicketSelect', 'load.getEventById', e);
        props.common.showToast('Oh no, we weren\'t able to load the event details, please try again.');

        props.common.hideLoading();
      });

    EventProvider.getProductsByEventId(eId)
      .then(ret => {
        
        if (!isValidProviderResult(ret) || !Array.isArray(ret.data)) {
          return;
        }

        setState(prevState => ({
          ...prevState,
          products: ret.data
        }));
      })
      .catch(e => Logger.error('EventTicketSelect', 'load.getProductsByEventId', e));

    EventProvider.getPackagesByEventId(eId)
      .then(ret => {
        
        if (!isValidProviderResult(ret) || !Array.isArray(ret.data)) {
          return;
        }

        setState(prevState => ({
          ...prevState,
          packages: ret.data
        }));
      })
      .catch(e => Logger.error('EventTicketSelect', 'load.getPackagesByEventId', e));
  };

  React.useEffect(load, []); // eslint-disable-line

  // Generate meta description from event data
  const metaDescription = `Buy tickets for ${state.event.name || 'this event'} at ${state.event.location_display || 'the venue'}. Get your tickets now.`;

  const pageTitle = state.event.name ? `Buy Tickets - ${state.event.name} - WeTicket` : 'Buy Tickets - WeTicket';

  let ticketComponents = [];

  for (const ticketPrice of state.ticketPrices) {

    if (ticketPrice.type === 'charity') {
      continue;
    }

    const isSoldOut = state.event.status === 'sold_out'
      || state.event.status === 'inactive'
      || ticketPrice.available_tickets <= 0;

    // Calculate max tickets considering venue capacity
    let maxTickets = ticketPrice.price === 0
      ? ticketPrice.available_tickets > 5
        ? 5
        : ticketPrice.available_tickets
      : ticketPrice.available_tickets > 15
        ? 15
        : ticketPrice.available_tickets;

    // Apply venue capacity limit if available
    const availableVenueCapacity = state.event.available_venue_capacity;
    if (availableVenueCapacity !== undefined && availableVenueCapacity !== null) {
      // Calculate total tickets already selected (excluding this ticket type)
      let totalSelectedTickets = 0;
      for (const [id, item] of Object.entries(totals.selectedTickets)) {
        if (id !== ticketPrice.id.toString()) {
          totalSelectedTickets += item.count || 0;
        }
      }
      
      // Calculate remaining venue capacity
      const remainingVenueCapacity = availableVenueCapacity - totalSelectedTickets;
      
      // Max is the minimum of ticket type limit and remaining venue capacity
      if (remainingVenueCapacity < maxTickets) {
        maxTickets = Math.max(0, remainingVenueCapacity);
      }
    }

    // Check if venue capacity is reached (even if ticket type has availability)
    const isVenueCapacityReached = availableVenueCapacity !== undefined 
      && availableVenueCapacity !== null 
      && maxTickets <= 0
      && !isSoldOut;

    ticketComponents.push(
      <DetailContainer
        key={ticketPrice.id}
        borderColor={Theme.Divider.Color}>

        <DetailContent
          padding={'0'}>

          <Text
            display={'block'}
            fontSize={FontSizes.Medium}
            fontFamily={FontFamilies.Bold}>
              {ticketPrice.title}

              { isSoldOut

                ? <b> ({ticketPrice.callout || 'Sold Out'})</b>

                : isVenueCapacityReached

                    ? <b> (Sold Out)</b>

                    : ticketPrice.available_tickets <= 10

                        ? <b> (Only {ticketPrice.available_tickets} left)</b>

                        : <></>
              }
          </Text>

          <Text
            display={'block'}
            fontSize={FontSizes.Smaller}
            padding={'0 12px 2px 0'}>
              {ticketPrice.description}
          </Text>

          <Text
            display={'block'}
            fontFamily={FontFamilies.Bold}
            fontSize={FontSizes.Small}>
              R{ticketPrice.price}
          </Text>

        </DetailContent>

        <div onClick={() => {
          if (isSoldOut) {
            props.common.showToast(ticketPrice.callout || 'Tickets sold out');
          } else if (isVenueCapacityReached) {
            props.common.showToast('Tickets sold out');
          }
        }}>
          <NumericSelect
            defaultValue={totals.selectedTickets[ticketPrice.id]?.count}
            disabled={isSoldOut || isVenueCapacityReached}
            max={maxTickets}
            onCounterChange={(count) => onTicketCounterChange(count, ticketPrice.id)}
          />
        </div>

      </DetailContainer>
    );
  }

  let productComponents = [];

  for (const product of state.products || []) {

    let variantComponents = [];

    for (const variant of product.variants || []) {

      const isSoldOut = variant.available_stock <= 0;

      variantComponents.push(
        <DetailContainer
          key={`variant-${variant.option_id}`}
          borderColor={variantComponents.length === 0 ? 'transparent' : Theme.Divider.Color}
          padding={'6px 0'}>

          <DetailContent
            padding={'0'}>

            <Text
              display={'block'}
              fontFamily={FontFamilies.Regular}>
                {variant.option_value}

                { isSoldOut

                  ? <span> (Sold Out)</span>

                  : variant.available_stock <= 15

                      ? <span style={{ fontSize: FontSizes.Small, fontFamily: FontFamilies.Regular }}> (Only {variant.available_stock} left)</span>

                      : <></>
                }
            </Text>

            <Text
              display={'block'}
              fontFamily={FontFamilies.Regular}
              fontSize={FontSizes.Small}>
                <b>R{variant.price}</b>
            </Text>

          </DetailContent>

          <div onClick={() => isSoldOut && props.common.showToast('Item sold out')}>
            <NumericSelect
              defaultValue={totals.selectedMerch[`variant-${variant.option_id}`]?.count}
              disabled={isSoldOut}
              max={variant.product_variant_id === 34 ? 1 : variant.available_stock}
              onCounterChange={(count) => onMerchCounterChange(count, product.product_id, variant.option_id)}
            />
          </div>

        </DetailContainer>
      );
    }

    if (product.is_simple_product) {

      const isSoldOut = product.available_stock <= 0;

      variantComponents.push(
        <DetailContainer
          key={`product-${product.product_id}`}
          borderColor={variantComponents.length === 0 ? 'transparent' : Theme.Divider.Color}
          padding={'6px 0'}>

          <DetailContent
            padding={'0'}>

            <Text
              display={'block'}
              fontFamily={FontFamilies.Regular}>
                {product.product_name}

                { isSoldOut

                  ? <span> (Sold Out)</span>

                  : product.available_stock <= 15

                      ? <span style={{ fontSize: FontSizes.Small, fontFamily: FontFamilies.Regular }}> (Only {product.available_stock} left)</span>

                      : <></>
                }
            </Text>

            <Text
              display={'block'}
              fontFamily={FontFamilies.Regular}
              fontSize={FontSizes.Small}>
                <b>R{product.price}</b>
            </Text>

          </DetailContent>

          <div onClick={() => isSoldOut && props.common.showToast('Item sold out')}>
            <NumericSelect
              defaultValue={totals.selectedMerch[`product-${product.product_id}`]?.count}
              disabled={isSoldOut}
              max={product.available_stock}
              onCounterChange={(count) => onMerchCounterChange(count, product.product_id)}
            />
          </div>
        </DetailContainer>
      );
    }

    productComponents.push(
      <DetailContainer
        key={`product-${product.product_id}`}
        borderColor={Theme.Divider.Color}>

        <DetailContent
          padding={'0'}>

          <Text
            display={'block'}
            fontFamily={FontFamilies.Bold}
            fontSize={'1.1rem'}>
              {product.product_name}
          </Text>

          <Text
            display={'block'}
            fontSize={FontSizes.Smaller}
            padding={'0 0 2px 0'}>
              {product.description}
          </Text>

          <MerchContainer>

            <div style={{padding: '10px 0 0 0'}}>
              <Image
                src={product.image_url}
                width={'200px'}
                height={'auto'}
                borderRadius={'8px'}
              />
            </div>

            <VariantContainer>{variantComponents}</VariantContainer>

          </MerchContainer>

        </DetailContent>

      </DetailContainer>
    );
  }

  return (

    <>
    {!props.common.isWidget &&
      <ShareMeta
        title={pageTitle}
        description={metaDescription}
        image={state.event.cover_media_url}>
        {state.event.location_display && <meta name="event:location" content={state.event.location_display} />}
        {state.event.displayDate && <meta name="event:date" content={state.event.displayDate} />}
        {state.event.priceDisplay && <meta name="event:price" content={state.event.priceDisplay} />}
      </ShareMeta>
    }

    <Text
      maxWidth={'1100px'}
      margin={'0 auto'}
      width={'100%'}
      display={'block'} 
      padding={'20px 15px 0 15px'} 
      fontSize={FontSizes.Small}
      color={Theme.Text.Color}
    >
      <span style={{cursor: 'pointer'}} onClick={() => props.common.navigate('/')}>← Back</span>
    </Text>

    <EventName>{state.event.name}</EventName>

    <Text display={'block'} padding={'0 15px 5px 15px'} textAlign={'center'} fontSize={FontSizes.Small}>{state.event.location_display}</Text>

    { !state.event.is_multi_event &&
      <Text display={'block'} padding={'0 15px 20px 15px'} textAlign={'center'} fontSize={FontSizes.Small}>{state.event.displayDate}</Text>
    }

    { state.event.is_multi_event &&
      <Text display={'block'} padding={'0 0 30px 0'} textAlign={'center'} fontSize={FontSizes.Small}></Text>
    }

    <FullWidthContainer>

      <StepperContainer>

        <Stepper
          items={getCheckoutSteps(state.event)}
          selectedIndex={0}
        />

      </StepperContainer>

    </FullWidthContainer>

    <Container isWidget={props.common.isWidget}>

      <MainContentContainer>

        { ticketComponents.length > 0 &&

          <div style={{ padding: '5px 15px 15px 15px' }}>

            <Card
              alignItems={'flex-start'}
              flexDirection={'column'}
              padding={'10px 0'}
              margin={'0'}>

              <Text fontSize={FontSizes.Big} fontFamily={FontFamilies.Bold} padding={'0 20px 2px 20px'}>Select Tickets</Text>

              <Text fontSize={FontSizes.Small} padding={'0 20px 10px 20px'}>Select your tickets below</Text>

              {(() => {
                const availableVenueCapacity = state.event.available_venue_capacity;
                if (availableVenueCapacity !== undefined && availableVenueCapacity !== null && availableVenueCapacity <= 15 && availableVenueCapacity > 0) {
                  return (
                    <div style={{ width: '100%', borderTop: `1px solid ${Theme.Divider.Color || '#eeeeee'}` }}>
                      <Text
                        fontSize={FontSizes.Small} 
                        padding={'10px 20px 10px 20px'}
                        color={Colors.Error || '#d32f2f'}
                        fontFamily={FontFamilies.Bold}>
                        Only {availableVenueCapacity} {availableVenueCapacity === 1 ? 'ticket' : 'tickets'} left
                      </Text>
                    </div>
                  );
                }
                return null;
              })()}

              {ticketComponents}

            </Card>

          </div>
        }

        { state.packages.length > 0 && state.packages.map((packageData) => {
          const packageId = packageData.id || 'package-1';
          const packageCount = totals.selectedPackages[packageId]?.count || 0;
          
          return (
            <div style={{ padding: '5px 15px 15px 15px' }}>
              <Card
                key={`package-${packageId}`}
                backgroundColor={Theme.Card.Background}
                alignItems={'flex-start'}
                flexDirection={'column'}
                padding={'20px'}
                margin={'0'}>

                <Text fontSize={FontSizes.Big} fontFamily={FontFamilies.Bold} padding={'0 0 10px 0'}>
                  {packageData.name}
                </Text>

                <Text fontSize={FontSizes.Small} padding={'0 0 15px 0'}>
                  {packageData.description}
                </Text>

                <PackageContainer>
                  <PackageImageContainer>
                    <Image
                      src={packageData.image_url}
                      width={'200px'}
                      height={'auto'}
                      borderRadius={'8px'}
                    />
                  </PackageImageContainer>

                  <PackageDetailsContainer>
                    <PriceAndSelectContainer>
                      <Text fontSize={FontSizes.Normal} fontFamily={FontFamilies.Bold} padding={'5px 0'}>
                        R{packageData.price}
                      </Text>

                      <NumericSelect
                        defaultValue={packageCount}
                        onCounterChange={(count) => onPackageCounterChange(count, packageData)}
                      />
                    </PriceAndSelectContainer>

                    {renderIncludedItems(packageData)}
                  </PackageDetailsContainer>
                </PackageContainer>

                {renderProductVariants(packageData)}
              </Card>
            </div>
          );
        })}

        { state.event.id !== 1000130 && productComponents.length > 0 &&

          <div style={{ padding: '5px 15px 15px 15px' }}>
            <Card
              alignItems={'flex-start'}
              flexDirection={'column'}
              padding={'10px 0'}
              margin={'0'}>

              <Text fontSize={FontSizes.Big} fontFamily={FontFamilies.Bold} padding={'0 20px 2px 20px'}>Select Products</Text>

              <Text fontSize={FontSizes.Small} padding={'0 20px 10px 20px'}>{description}</Text>

              { productComponents }

            </Card>
          </div>
        }

        <MobileContentSpace
          height={'80px'}
        />

        <DesktopContentSpace
          height={'45px'}
        />

        <ActionContainerPopupOverlay
          show={showSummary}
          onClick={onHideSummaryClick}
        />

        <ActionContainerPopup
          show={showSummary}>

          <EventMobileTicketSummary
            totals={totals}
            onArrowClick={onHideSummaryClick}
            checkoutDisabled={!areAllVariantsSelected()}
          />

        </ActionContainerPopup>

        <ActionContainer>

          <ArrowContainer
            onClick={onShowSummaryClick}>

            <Arrow
              active={true}
              size={'10px'}
              direction={'up'}
            />

          </ArrowContainer>
          
          <DetailContent
            padding={'0'}>

            <DetailContentText fontSize={FontSizes.Small}>Price:</DetailContentText>
            <DetailContentText fontSize={'1.2rem'} bold>{`R${totals.price}`}</DetailContentText>
            
          </DetailContent>

          <Button 
            onClick={handleCheckout}>Checkout</Button>

        </ActionContainer>

      </MainContentContainer>

      <SideContentContainer>

        <SideContent
          marginTop={'5px'}
          top={'90px'}
          sticky={true}>

          <EventMobileTicketSummary
            totals={totals}
            packages={state.packages}
            checkoutDisabled={!areAllVariantsSelected()}
            onCheckoutClick={handleCheckout}
          />

        </SideContent>

      </SideContentContainer>

      <Modal 
        show={showProductCheckModal} 
        onClose={() => {
          setShowProductCheckModal(false);
          setProductCheckMessage('');
        }}
        backgroundColor={Theme.Card.Background}>
        <div style={{ padding: '20px', maxWidth: '500px' }}>
          <Text 
            fontSize={FontSizes.Big} 
            fontFamily={FontFamilies.Bold} 
            padding={'0 0 15px 0'}>
            Are you Over 18?
          </Text>
          
          <div 
            style={{ fontSize: FontSizes.Regular, padding: '0 0 20px 0', maxHeight: '80vh', overflowY: 'auto' }}>
            Alcohol is not for sale to persons under the age of 18. By proceeding, you confirm that you are of legal drinking age in South Africa.
            <br />
            <br />
            All liquor is sold and supplied by:
            <br />
            <br />
            Boland Rugby Unie (License No: WCP/044940)
            <br />
            <br />
            You will be required to present a valid South African ID, Passport, or Driver’s License upon delivery. No alcohol will be left with a minor or at an unattended premises.
            <br />
            <br />
            Warning: Alcohol reduces driving ability, don't drink and drive. Alcohol is addictive.
          </div>
          
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <Button
              onClick={() => {
                setShowProductCheckModal(false);
                setProductCheckMessage('');
              }}
              backgroundColor={Colors.Gray}
              textColor={Colors.White}
              width={'120px'}>
              Cancel
            </Button>
            
            <Button
              onClick={proceedToCheckout}
              width={'120px'}>
              I am 18+
            </Button>
          </div>
        </div>
      </Modal>

    </Container>
    </>
  );
};

export const EventTicketSelect = withCommon(EventTicketSelectUI, { addDefaultMetaTags: false });